import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { PostHogProvider } from 'posthog-js/react'
import './index.css'
import App from './App.tsx'
import { AuthProvider } from './contexts/AuthContext'
import { initSentry, Sentry } from './sentry'
import { initPostHog, posthog } from './posthog'
import { SentryErrorFallback } from './components/SentryErrorFallback'

initSentry()
initPostHog()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<SentryErrorFallback />}>
      <PostHogProvider client={posthog}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </PostHogProvider>
    </Sentry.ErrorBoundary>
  </StrictMode>,
)
